import React, { useEffect, useState } from "react";

import IGame from "../interfaces/Game";
import { Auth } from "@firebase/auth";
import { ProgressBar } from "react-bootstrap";
import Button from "@restart/ui/esm/Button";
import { oembed } from "@loomhq/loom-embed";
import { Navigate, useNavigate } from "react-router";

export interface ResultsProps {
	gameData: IGame;
	auth: Auth;
}

interface Result {
	uid: string;
	score: number;
	name: string | null;
	image: string | null;
	loomUrl?: string;
}

const Results: React.FC<ResultsProps> = ({ gameData, auth }) => {
	const [results, setResults] = useState<Result[]>();
	const [loomUrl, setLoomUrl] = useState<string>();
	const [copied, setCopied] = useState(false);

	const myStatus = gameData?.status?.[auth.currentUser?.uid ?? ""];

	useEffect(() => {
		if (gameData?.status && auth.currentUser?.uid) {
			const parsedResults: Result[] = [];
			const answers = Object.keys(gameData?.status);
			answers.forEach((answer) => {
				if (answer !== auth.currentUser?.uid && gameData?.status[answer].loomUrl) {
					let score = 0;
					gameData?.status[answer].questions.forEach((question, index) => {
						if (
							question.answer !== undefined &&
							myStatus.questions[index].answer !== undefined &&
							question.answer === myStatus.questions[index].answer
						) {
							score++;
						}
					});
					parsedResults.push({
						uid: answer,
						score,
						name: gameData?.status[answer].name,
						image: gameData?.status[answer].image,
						loomUrl: gameData?.status[answer].loomUrl
					});
				}
			});
			setResults(parsedResults.sort((a, b) => b.score - a.score));
		}
	}, [gameData]);

	useEffect(() => {
		if (copied) {
			setTimeout(() => {
				setCopied(false);
			}, 3000);
		}
	}, [copied]);

	if (!results) {
		return null;
	}

	return (
		<>
			<div className={`watch ${loomUrl ? "active" : ""}`}>
				<div className="deco">
					<div dangerouslySetInnerHTML={{ __html: loomUrl ?? "" }}></div>
					<Button
						onClick={() => {
							setLoomUrl(undefined);
						}}
					>
						<div className="deco">Close</div>
					</Button>
				</div>
			</div>
			{!loomUrl && (
				<div className="results">
					<div className="deco">
						<div className="invite-others">
							<h5 className="display">Invite others to see your Christmas Compatibility Score.</h5>
							<Button
								onClick={() => {
									var dummy = document.createElement("input"),
										text = window.location.href;

									document.body.appendChild(dummy);
									dummy.value = text;
									dummy.select();
									document.execCommand("copy");
									document.body.removeChild(dummy);
									setCopied(true);
								}}
							>
								<div className="deco">{copied ? "Link Copied!" : "Copy Link"}</div>
							</Button>
						</div>
						{results?.map((result) => {
							return (
								<div className="result">
									<div
										className="result-image"
										style={{ backgroundImage: result.image ? `url(${result.image})` : undefined }}
									></div>
									<div className="result-details">
										<div className="result-name display">{result.name}</div>
										<ProgressBar striped variant="danger" now={result.score * 10} />
										{result.loomUrl && (
											<Button
												onClick={async () => {
													if (result.loomUrl) {
														const { html } = await oembed(result.loomUrl, { width: 400 });
														setLoomUrl(html);
													}
												}}
											>
												<div className="deco">Watch</div>
											</Button>
										)}
									</div>
								</div>
							);
						})}
					</div>
				</div>
			)}
		</>
	);
};

export default Results;
